// src/services/ga4Service.js
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

// ✅ Realtime ziyaretçi sayısı
export const getRealtimeVisitors = async () => {
  try {
    const func = httpsCallable(functions, 'getRealtimeVisitors');
    const result = await func();
    console.log('🟢 Realtime result:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Realtime hatası:', error);
    return { success: false, error: error.message };
  }
};

// ✅ Günlük trend
export const getDailyTrend = async (days = 30) => {
  try {
    const func = httpsCallable(functions, 'getDailyTrend');
    const result = await func({ days });
    console.log('📊 Daily trend result:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Daily trend hatası:', error);
    return { success: false, error: error.message };
  }
};

// ✅ Saatlik dağılım
export const getHourlyDistribution = async () => {
  try {
    const func = httpsCallable(functions, 'getHourlyDistribution');
    const result = await func();
    console.log('⏰ Hourly result:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Hourly hatası:', error);
    return { success: false, error: error.message };
  }
};

// ✅ Cihaz dağılımı
export const getDeviceData = async (days = 30) => {
  try {
    const func = httpsCallable(functions, 'getDeviceData');
    const result = await func({ days });
    console.log('📱 Device result:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Device hatası:', error);
    return { success: false, error: error.message };
  }
};

// ✅ Tarayıcı dağılımı
export const getBrowserData = async (days = 30) => {
  try {
    const func = httpsCallable(functions, 'getBrowserData');
    const result = await func({ days });
    console.log('🌐 Browser result:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Browser hatası:', error);
    return { success: false, error: error.message };
  }
};

// ✅ Genel analytics
export const getVisitorAnalytics = async (days = 30) => {
  try {
    const func = httpsCallable(functions, 'getVisitorAnalytics');
    const result = await func({ days });
    console.log('📈 Analytics result:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Analytics hatası:', error);
    return { success: false, error: error.message };
  }
};

// ✅ YENİ - En çok görüntülenen ürünler
export const getTopViewedProducts = async (days = 30, limit = 10) => {
  try {
    const func = httpsCallable(functions, 'getTopViewedProducts');
    const result = await func({ days, limit });
    console.log('🛍️ Top products result:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Top products hatası:', error);
    return { success: false, error: error.message };
  }
};

// ✅ YENİ - Trafik kaynakları
export const getTrafficSources = async (days = 30) => {
  try {
    const func = httpsCallable(functions, 'getTrafficSources');
    const result = await func({ days });
    console.log('🌍 Traffic sources result:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Traffic sources hatası:', error);
    return { success: false, error: error.message };
  }
};